import { fetchit } from 'lib';
import { API_COUPON, API_REDEEM } from 'config/api';
import useRedeem from 'store/useRedeem';

interface requestBody {
  product: string;
  userId: string;
  balance: number;
}

export const getProducts = async (placeId: String) => {
  if (!placeId) return;
  const data = await fetchit(API_REDEEM + '/?place=' + placeId, null, 'GET');
  useRedeem.setState({ products: data.results });
  return data;
};

export const getCouponHistory = async (userID: string) => {
  if (!userID) return;
  const data = await fetchit(API_COUPON + '/?userId=' + userID, null, 'GET');
  useRedeem.setState({ history: data.results });
  return data;
};

export const createNewCoupon = (data: requestBody) => {
  if (!data) return;
  return fetchit(API_COUPON, data, 'POST');
};
